import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { alertActions } from "../_actions";

const styles = theme => ({
    root: {
        position: "relative",
        overflow: "hidden"
    },
    appFrame: {
        width: 360,
        height: 360,
        backgroundColor: theme.palette.background.paper
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    button: {
        marginBottom: theme.spacing.unit
    },
    fab: {
        position: "absolute",
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2
    },
    fabMoveUp: {
        transform: "translate3d(0, -46px, 0)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.easeOut
        })
    },
    fabMoveDown: {
        transform: "translate3d(0, 0, 0)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp
        })
    },
    snackbar: {
        
    },
    snackbarContent: {
        width: 360
    }
});

class FabIntegrationSnackbar extends React.Component {
    handleClose = () => {
        const { dispatch } = this.props;
        dispatch(alertActions.clear());
    };

    render() {
        const {
            classes,
            alert,
            showCloseBtn,
            autoHideDuration,
            tapOutsideToClose
        } = this.props;
        return (
            <Snackbar
                open={alert.message ? true : false}
                autoHideDuration={autoHideDuration}
                onClose={tapOutsideToClose === true ? this.handleClose : null}
                ContentProps={{
                    "aria-describedby": "snackbar-fab-message-id",
                    className: classes.snackbarContent
                }}
                message={alert.message}
                action={
                    showCloseBtn ? (
                        <Button
                            color="inherit"
                            size="small"
                            onClick={this.handleClose}
                        >
                            Close
                        </Button>
                    ) : null
                }
                className={classes.snackbar}
            />
        );
    }
}

FabIntegrationSnackbar.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert
    };
}

const styleSnackBar = withStyles(styles)(FabIntegrationSnackbar);
const connectedSnackbar = connect(mapStateToProps)(styleSnackBar);

export { connectedSnackbar as SnackBar };



// WEBPACK FOOTER //
// ./src/SnackBar/SnackBar.js